// extracted by mini-css-extract-plugin
export default {"container":"style_container__AQK4s","value":"style_value__TPsGp","text":"style_text__LvZC3"};